<div class="auth-step--container">
  <div class="auth--card">
    <ng-content
      select="[authCard]"
      data-test-id="authStepContainer"
    ></ng-content>
  </div>
</div>
